var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationSurveyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9411 0 36 8.05876 36 18C36 27.9412 27.9411 36 18 36C8.05889 36 0 27.9412 0 18C0 8.05876 8.05889 0 18 0Z",
    fill: "#41B5C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.238 8.43644V7H13.9078V8.43644H10V29H25.1459V8.43644H21.238ZM15.1986 8.29079H19.9472V9.87283H15.1986V8.29079ZM23.8551 27.7092H11.2908V9.72723H13.9078V11.1636H21.238V9.72723H23.8551V27.7092H23.8551Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2227 16.3715L13.6453 15.6493L12.6371 16.4553L14.2111 18.424L16.6526 15.44L15.6536 14.6226L14.2227 16.3715Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5389 20.2939L14.6181 21.2147L13.6973 20.2939L12.7846 21.2066L13.7054 22.1274L12.7846 23.0482L13.6973 23.9609L14.6181 23.0401L15.5389 23.9609L16.4517 23.0482L15.5309 22.1274L16.4517 21.2066L15.5389 20.2939Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9602 16.1213H22.435V17.4121H17.9602V16.1213Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9602 21.482H22.435V22.7728H17.9602V21.482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSurveyIcon);
export default __webpack_public_path__ + "static/media/notification_survey_icon.659499644658b05010219635486579cd.svg";
export { ForwardRef as ReactComponent };